import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Icon from 'components/Icon';
import helperMarkdownToComponent from 'helpers/Data';
import { sendEmail } from './EmailSubmissionFormActions';

import Style from './EmailSubmissionForm.module.scss';

class EmailSubmissionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailInput: '',
    };
  }

  componentDidUpdate(prevProps) {
    const { emailSent, onSubmitCallback } = this.props;
    const { emailSent: prevEmailSent } = prevProps;
    const emailWasSent = !prevEmailSent && emailSent;
    if (emailWasSent) onSubmitCallback();
  }

  onEmailChange = e => {
    const emailInput = e.target.value;
    this.setState({ emailInput });
  };

  onEmailSubmit = submitButtonText => {
    const { emailInput } = this.state;
    const { accessToken, deviceId, sendEmail } = this.props;
    if (!emailInput) return;
    sendEmail({ email: emailInput, accessToken, deviceId });
  };

  renderForm() {
    const { render } = this.props;
    const { emailInput } = this.state;
    if (!render) return null;

    const {
      auth_legalAgreement: legalCopy,
      mvpdEmailCapture_button: submitButtonText,
      mvpdEmailCapture_header: emailHeaderText,
      mvpdEmailCapture_placeholder: emailPlaceholderText,
    } = window.Language;

    const buttonEnabled = emailInput.length > 0;
    const buttonClasses = [Style.emailSubmitButton];
    if (buttonEnabled) buttonClasses.push(Style.enabled);

    return (
      <div className={Style.emailFormContainer} data-test="email-form-container">
        <div className={Style.emailFormHeader} data-test="email-form-header">
          {emailHeaderText}
        </div>
        <div className={Style.emailInputContainer}>
          <input
            className={Style.emailInput}
            data-test="email-form-input"
            type="email"
            placeholder={emailPlaceholderText}
            value={emailInput}
            onChange={this.onEmailChange}
          />
          <button
            className={classNames(buttonClasses)}
            data-test="email-form-submit-button"
            disabled={!buttonEnabled}
            onClick={() => {
              this.onEmailSubmit(submitButtonText);
            }}
            type="button"
          >
            {submitButtonText}
          </button>
        </div>
        <div className={Style.legalDisclaimer} data-test="email-form-disclaimer">
          {helperMarkdownToComponent(legalCopy, null, {
            Paragraph: props => {
              const { children } = props;
              if (!children) return null;
              return <p className={Style.legalDisclaimerText}>{children}</p>;
            },
            Link: props => (
              <a
                href={props.href}
                className={Style.legalDisclaimerLink}
                target="noopener noreferrer"
              >
                {props.children}
              </a>
            ),
          })}
        </div>
      </div>
    );
  }

  renderSuccess = () => {
    const { mvpdEmailCapture_success: headerText } = window.Language;

    return (
      <div className={Style.emailSuccessContainer} data-test="email-success-message">
        <div className={Style.emailFormHeader} data-test="email-form-header">
          {headerText}
        </div>
        <div className={Style.emailSuccessIcon}>
          <Icon
            size="large"
            color="white"
            icon="checkmark-circle"
            theme={Style}
            viewBox="0 0 71 71"
          />
        </div>
      </div>
    );
  };

  render() {
    const { emailSent } = this.props;
    return emailSent ? this.renderSuccess() : this.renderForm();
  }
}

const mapStateToProps = ({ emailSubmissionForm }) => ({
  emailAccessToken: emailSubmissionForm.emailAccessToken,
  emailSent: emailSubmissionForm.emailSent,
});

export default connect(mapStateToProps, {
  sendEmail,
})(EmailSubmissionForm);

EmailSubmissionForm.defaultProps = {
  accessToken: null,
  account: {},
  deviceId: null,
  onSubmitCallback: () => {},
  render: true,
};

EmailSubmissionForm.propTypes = {
  accessToken: PropTypes.string,
  account: PropTypes.shape({}),
  deviceId: PropTypes.string,
  emailSent: PropTypes.bool.isRequired,
  onSubmitCallback: PropTypes.func,
  render: PropTypes.bool,
  sendEmail: PropTypes.func.isRequired,
};
